import React from 'react';
import styled from 'styled-components';
import { legal as navItems } from './data/navItems';

const s = {
  List: styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
  `,
  Item: styled.li`
    display: inline-block;
    :after {
      content: '|';
      display: inline-block;
      margin: 0 15px;
      height: 100%;
    }
    :last-child:after {
      display: none;
    }
  `,
  Link: styled.a`
    color: inherit;
  `,
};

// TODO: use this component in all footers
const LegalLinks: React.FC<{ className?: string }> = (props) => {
  return (
    <s.List className={props.className}>
      {navItems.map((navItem, i) => (
        <s.Item key={i}>
          <s.Link href={navItem.to}>{navItem.label}</s.Link>
        </s.Item>
      ))}
    </s.List>
  );
};

export default LegalLinks;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/Footer/LegalLinks.tsx